import { combineReducers } from "redux"
import Layout from "./layout/reducer"
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import {
  forgetPassword,
  resetPassword,
  updatePassword,
} from "./auth/password/reducer"
import Profile from "./auth/profile/reducer"
import Campaign from "./campaign/reducer"
import Role from "./roles/reducer"
import accounts from "./accounts/reducer"
import Ads from "./creatives/reducer"
import ChangeHistory from "./change-history/reducer"
import AdminChangeHistory from "./admin-change-history/reducer"
import AdminChangeHistoryFilters from "./admin-change-history-filters/reducer"
import Brands from "./brands/reducer"
import SfCommonData from "./sf_common_data/reducer"
import Dashboard from "./dashboard/reducer"
import Analytics from "./analytics/reducer"
import Conversions from "./conversions/reducer"
import AdGroupLocations from "./ad-group-locations/reducer"
import AdGroupAd from "./ad-group-ad/reducer"
import BannerMessages from "./banner-messages/reducer"
import UserSmartViews from "./user_smart_views/reducer"
import Receipts from "./receipts/reducer"
import PaymentMethods from "./payment_methods/reducer"
import ScheduledReports from "./scheduled_reports/reducer"
import AdminScheduledReports from "./admin/admin_scheduled_reports/reducer"
import EmailEvents from "./email-events/reducer"
import AdminUsers from "./admin/users/reducer"
import AdminUserLogin from "./admin/user-login/reducer"
import featuresFlags from "./admin/feature-flags/reducer"
import AdminUserSignup from "./admin/Authentication/signup/reducer"
import LoginAdminUser from "./admin/Authentication/login/reducer"
import AdminUserRoles from "./admin/roles/reducer"
import AdminNotifications from "./admin/admin-notifications/reducer"
import AdminManageInternalUsers from "./admin/admin-internal-user/reducer"
import Invoices from "./invoices/reducer"
import insurance_carrier from "./insurance-carrier/reducer"
import UnlockAdminUser from "./admin/Authentication/Unlock-Account/reducer"
import adminUserColumnPreference from "./admin/sticky-columns/reducer"
import adminDashboardColumnPreference from "./admin/admin-dashboard-sticky-columns/reducer"
import UpdateClientUser from "./EditedByAdmin/reducer"
import UserCampaignColumnPreference from "./user_column_preference/campaign-sticky-columns/reducer"
import UserAdgroupColumnPreference from "./user_column_preference/adgroup-sticky-columns/reducer"
import UserSourceSettingsColumnPreference from "./user_column_preference/source-setting-sticky-columns/reducer"
import UserLeadProfileColumnPreference from "./user_column_preference/lead-profile-sticky-columns/reducer"
import UserCallProfileColumnPreference from "./user_column_preference/call-profile-sticky-columns/reducer"
import UserLeadColumnPreference from "./user_column_preference/lead-sticky-columns/reducer"
import UserCallColumnPreference from "./user_column_preference/call-sticky-columns/reducer"
import UserCallsDashboardColumnPreference from "./user_column_preference/calls-dashboard-sticky-columns/reducer"
import UserClicksDashboardColumnPreference from "./user_column_preference/clicks-dashboard-sticky-column/reducer"
import UserLeadsDashboardColumnPreference from "./user_column_preference/leads-dashboard-sticky-column/reducer"
import UserConversionLogColumnPreference from "./user_column_preference/conversion-log-sticky-columns/reducer"
import UserAnalyticsColumnPreference from "./user_column_preference/analytics-sticky-columns/reducer"
import UserSyndiClicksDashboardColumnPreference from "./user_column_preference/syndi-clicks-dashboard-sticky-column/reducer"
import ZipTiers from "./zip_tiers/reducer"
import LeadPrices from "./lead_prices/reducer"
import CallPrices from "./call_prices/reducer"
import QuoteFunnelsPrices from "./quote_funnels_prices/reducer"
import quoteFunnelsStatsReducer from "./quote-funnels-stats/reducer"
import marketplaceStatsReducer from "./marketplace-stats/reducer"
import Notification from "./notifications/reducer"
import { AdminInvoices, InvoiceVersion } from "./admin/admin-invoices/reducer"
import CampaignAnalysis from "./campaign-analysis/reducer"
import Leads from "./leads/reducer"
import Calls from "./calls/reducer"
import NotificationsTerminal from "./notifications-terminal/reducer"
import AdminInsuranceCarriers from "./admin-insurance-carrier/reducer"
import {
  resetAdminPassword,
  forgotAdminPassword,
  updateAdminPassword
} from "./admin/Authentication/password/reducer"
import ApiTokens from "./api-tokens/reducer"
import Integration from "./integration/reducer"
import IntegrationV2 from "./integration_v2/reducer"
import ClientEmailEvents from "./client-email-events/reducer"
import AdminUserActivity from "./user-activity/reducer"
import TermsOfServices from "./terms-of-service/reducer"
import AdminRefundReasons from "./admin-refund-reasons/reducer"
import AdminPaymentTerms from "./admin-payment-terms/reducer"
import AdminBillingEvents from "./admin-billing-events/reducer"
import AdminTwilioNumbers from "./admin-twilio-numbers/reducer"
import AdminLeadPrices from "./admin-lead-prices/reducer"
import AdminCallPrices from "./admin-call-prices/reducer"
import AdminDashboard from "./admin/dashboard/reducer"
import AdminLeadRefunds from "./admin-lead-refunds/reducer"
import WhitelistedBrandLogin from "./admin/whitelisted-brands/reducer"
import AdminSfFilters from "./admin-sf-filters/reducer"
import PlatformSettings from "./platform-settings/reducer"
import AdminPlatformSettings from "./admin-platform-settings/reducer"
import AdminFilterPackages from "./admin-filter-packages/reducer"
import adgroupNotesReducer from "./notes/adgroup_notes/reducer"
import campaignNotesReducer from "./notes/campaign_notes/reducer"
import sourceSettingsNotesReducer from "./notes/source_settings_notes/reducer"
import leadNotesReducer from "./notes/lead_notes/reducer"
import CustomizeColumnsOrder from "./customize-columns-order/reducer"
import QuoteFunnelRedcuer from "./quote_funnels/reducer"
import QuoteFunnelAnswersAgentProfileReducer from "./quote_funnels/answers/reducer"
import Prospects from "./prospects/reducer"
import AllProspects from "./fetch-all-prospects/reducer"
import QuoteFunnelsCCPA from "./quotes_funnel_ccpa/reducer"
import CustomizeOrder from "./customize-order/reducer"
import CustomizeOrderForAdmin from "./admin/admin-customize-column-order/reducer"
import ExportEmail from "./export-email/reducer"
import CallSummary from "./call-summary/reducer"
import AnswerFromQuery from "./call-summary-qa/reducer"
import DevDashboard from "./admin/dev-dashboard/reducer"
import StatusMonitor from "./admin/status-monitor/reducer"
import AutomationTestsReducer from "./admin/automation-tests/reducer"
import RdsMonitorReducer from "./admin/rds-monitor/reducer"
import SingleActionDispatch from "./single-action-dispatch/reducer"
import AdminIntegrationLogs from "./admin/admin-integration-logs/reducer"
import AdminBulkEditJobs from "./admin/admin-bulk-edit-jobs/reducer"
import RefundPolicy from "./refund-policy/reducer"
import AdminCampaignFulFillment from "./admin/admin-campaign-fulfillment/reducer"
import ClientCampaignFulfillment from "./campaign-fulfillment/reducer"
import DashboardV4 from "./dashboard-v4/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  forgetPassword,
  resetPassword,
  updatePassword,
  Profile,
  Campaign,
  Role,
  accounts,
  Ads,
  ChangeHistory,
  AdminChangeHistory,
  AdminChangeHistoryFilters,
  Brands,
  SfCommonData,
  Dashboard,
  Analytics,
  ApiTokens,
  Conversions,
  AdGroupLocations,
  AdGroupAd,
  BannerMessages,
  Receipts,
  PaymentMethods,
  UserSmartViews,
  ScheduledReports,
  AdminScheduledReports,
  EmailEvents,
  AdminUsers,
  AdminUserLogin,
  WhitelistedBrandLogin,
  featuresFlags,
  AdminUserSignup,
  LoginAdminUser,
  AdminUserRoles,
  AdminNotifications,
  AdminManageInternalUsers,
  resetAdminPassword,
  forgotAdminPassword,
  Invoices,
  insurance_carrier,
  Notification,
  UnlockAdminUser,
  adminUserColumnPreference,
  adminDashboardColumnPreference,
  UpdateClientUser,
  UserCampaignColumnPreference,
  UserAdgroupColumnPreference,
  UserSourceSettingsColumnPreference,
  UserLeadProfileColumnPreference,
  UserCallProfileColumnPreference,
  UserLeadColumnPreference,
  UserCallColumnPreference,
  UserCallsDashboardColumnPreference,
  UserClicksDashboardColumnPreference,
  UserLeadsDashboardColumnPreference,
  UserConversionLogColumnPreference,
  UserAnalyticsColumnPreference,
  UserSyndiClicksDashboardColumnPreference,
  ZipTiers,
  updateAdminPassword,
  LeadPrices,
  CallPrices,
  QuoteFunnelsPrices,
  quoteFunnelsStatsReducer,
  marketplaceStatsReducer,
  AdminInvoices,
  CampaignAnalysis,
  Integration,
  IntegrationV2,
  Leads,
  Calls,
  NotificationsTerminal,
  InvoiceVersion,
  ClientEmailEvents,
  CustomizeColumnsOrder,
  AdminInsuranceCarriers,
  AdminUserActivity,
  TermsOfServices,
  AdminRefundReasons,
  AdminPaymentTerms,
  AdminBillingEvents,
  AdminTwilioNumbers,
  AdminLeadPrices,
  AdminCallPrices,
  AdminDashboard,
  AdminLeadRefunds,
  AdminSfFilters,
  adgroupNotesReducer,
  campaignNotesReducer,
  sourceSettingsNotesReducer,
  leadNotesReducer,
  PlatformSettings,
  AdminPlatformSettings,
  AdminFilterPackages,
  QuoteFunnelRedcuer,
  QuoteFunnelAnswersAgentProfileReducer,
  Prospects,
  AllProspects,
  QuoteFunnelsCCPA,
  CustomizeOrder,
  CustomizeOrderForAdmin,
  ExportEmail,
  CallSummary,
  AnswerFromQuery,
  DevDashboard,
  StatusMonitor,
  AutomationTestsReducer,
  RdsMonitorReducer,
  SingleActionDispatch,
  AdminIntegrationLogs,
  AdminBulkEditJobs,
  RefundPolicy,
  AdminCampaignFulFillment,
  ClientCampaignFulfillment,
  DashboardV4,
})

export default rootReducer
